import { render } from "./Boolean.vue?vue&type=template&id=37099508"
import script from "./Boolean.vue?vue&type=script&setup=true&lang=js"
export * from "./Boolean.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Filter/Types/Boolean.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37099508"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37099508', __exports__)) {
    api.reload('37099508', __exports__)
  }
  
  module.hot.accept("./Boolean.vue?vue&type=template&id=37099508", () => {
    api.rerender('37099508', render)
  })

}


export default __exports__